/**
 * Help tab stub. Carries the CAM escalation surface so testers always have a
 * human route visible (the Big PRD's safety posture).
 */
import { Box, Stack, Typography } from '@mui/material';

import { PageTemplate } from '@karehero/llama/pwa/templates/PageTemplate/PageTemplate';
import { PageHeader } from '@karehero/llama/pwa/atoms/PageHeader/PageHeader';
import { Card } from '@karehero/llama/components/atoms/Card/Card';
import { Button } from '@karehero/llama/components/atoms/Button/Button';
import { Icon } from '@karehero/llama/components/atoms/Icon/Icon';

import { useNavigation } from '@/hooks/useNavigationContext';
import { useCaptureFlow } from './CaptureFlowContext';
import { palette } from './components/palette';

export const HelpTab = () => {
  const navigate = useNavigation();
  const { camContactRequested, requestCamContact } = useCaptureFlow();
  return (
    <PageTemplate
      maxWidth='sm'
      headerSlot={
        <PageHeader
          title='Help'
          description="Real people, whenever you're unsure."
        />
      }
      contentSlot={
        <Stack spacing={2}>
          <Card isFullWidth>
            <Stack sx={{ alignItems: 'flex-start' }} spacing={1.5}>
              <Icon icon='user-headset' fontSize={26} />
              <Typography variant='h6'>Talk to your care manager</Typography>
              {camContactRequested ? (
                <>
                  <Typography sx={{ fontSize: 14 }}>Message sent.</Typography>
                  <Typography sx={{ color: palette.mutedText, fontSize: 14 }}>
                    Sam, your care manager, can see what you've captured and
                    will come back to you today.
                  </Typography>
                </>
              ) : (
                <>
                  <Typography sx={{ color: palette.mutedText, fontSize: 14 }}>
                    Your care manager can talk through anything you've captured,
                    checked, or are worried about.
                  </Typography>
                  <Button
                    ariaLabel='Message your care manager'
                    variant='primary'
                    onPress={requestCamContact}
                  >
                    Message your care manager
                  </Button>
                </>
              )}
            </Stack>
          </Card>

          {/* Team-only strawman link, deliberately quiet */}
          <Box
            component='button'
            onClick={() => navigate('/cam')}
            sx={{
              alignSelf: 'center',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              color: palette.mutedText,
              fontSize: 11,
              textDecoration: 'underline',
            }}
          >
            Team only: CAM view strawman
          </Box>
        </Stack>
      }
    />
  );
};

export default HelpTab;
